import React from 'react';
import cx from 'classnames';
import { TabPanelsTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

// TypeScript declarations for Tailwind Plus Elements
/* eslint-disable @typescript-eslint/no-namespace */
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'el-tab-panels': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        class?: string;
        key?: string;
      };
    }
  }
}
/* eslint-enable @typescript-eslint/no-namespace */

type TabPanelsProps = {
  id: string;
  editorClassName?: string;
  children: React.ReactNode;
  isEditor?: boolean;
} & TabPanelsTreeNodeData;

export const TabPanels = React.forwardRef<HTMLElement, TabPanelsProps>(
  ({ id, className, editorClassName, children, isEditor = false, ...props }, ref) => {
    return (
      <el-tab-panels
        ref={ref}
        id={id}
        class={cx(transformToContainerQueries(className, { isEditor }), editorClassName)}
        {...props}
      >
        {children}
      </el-tab-panels>
    );
  },
);

TabPanels.displayName = 'TabPanels';
